import { Component, OnInit } from "@angular/core";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";

@Component({
  selector: "alert-dialog",
  template: `
    <div style="min-height: 50px;overflow: hidden;">
      <div style="float:left;">
        <div class="alert-title">{{ titulo }}</div>
        <span
          [class.error-message]="!status"
          [class.success-message]="status"
          >{{ mensaje }}</span
        >
      </div>
      <div style="float:right;" *ngIf="action" class="snackButtonContainer">
        <button mat-button class="snackButton" (click)="aceptar()">
          Aceptar
        </button>
        <ng-container *ngIf="!blockCancel">
          <button mat-button class="snackButton" (click)="cancelar()">
            Cancelar
          </button>
        </ng-container>
      </div>
    </div>
  `,
})
export class AlertComponent {
  status: boolean;
  titulo: string;
  action: boolean;
  mensaje: string;
  blockCancel: boolean = false;
  snackBarRef: MatSnackBarRef<AlertComponent>;

  private cancelar(): void {
    this.snackBarRef.dismiss();
  }

  private aceptar(): void {
    this.snackBarRef.dismiss();
  }
}
